import { useTranslate } from "ra-core";

import {
  claveEmbudo,
  claveEtapa,
  definicionEtapa,
  EMBUDOS,
  etapasDe,
} from "../dominio/etapas";
import { EtiquetaEtapa } from "../negocios/EtiquetaEtapa";

/**
 * Ajustes → Etapas (solo lectura): el catálogo cerrado de los embudos Ventas y Clientes
 * (Robert, 02/10/2026), cómo se llega a cada etapa y quién la trabaja. Cambiarlo es una
 * migración, no un ajuste.
 */
export const EtapasAjustes = () => {
  const translate = useTranslate();
  return (
    <section className="rounded-lg border bg-card px-4 py-3 space-y-4">
      <p className="text-sm text-muted-foreground">
        {translate("nevora.ajustes_etapas.ayuda")}
      </p>
      {EMBUDOS.map((embudo) => (
        <div key={embudo} className="space-y-2">
          <h3 className="etiqueta">{translate(claveEmbudo(embudo))}</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-xs text-muted-foreground">
                  <th scope="col" className="py-2 pr-4 font-medium">
                    {translate("nevora.ajustes_etapas.etapa")}
                  </th>
                  <th scope="col" className="py-2 pr-4 font-medium">
                    {translate("nevora.ajustes_etapas.como")}
                  </th>
                  <th scope="col" className="py-2 font-medium">
                    {translate("nevora.ajustes_etapas.quien")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {etapasDe(embudo).map((e) => {
                  const d = definicionEtapa(e);
                  return (
                    <tr key={e} className="border-b last:border-b-0 align-top">
                      <td className="py-2 pr-4">
                        <EtiquetaEtapa etapa={e} />
                        <span className="sr-only">
                          {translate(claveEtapa(e))}
                          {d.aparcada
                            ? ` (${translate("nevora.ajustes_etapas.aparcada")})`
                            : ""}
                        </span>
                      </td>
                      <td className="py-2 pr-4">
                        {translate(`nevora.ajustes_etapas.como_${e}`)}
                      </td>
                      <td className="py-2 text-muted-foreground">
                        {translate(`nevora.ajustes_etapas.quien_${d.quien}`)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </section>
  );
};
